import { render, staticRenderFns } from "./MemberSelect.vue?vue&type=template&id=056ff337&"
import script from "./MemberSelect.vue?vue&type=script&lang=ts&"
export * from "./MemberSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports